import { connect } from 'react-redux';

import { IApplicationState } from '../../types/redux';
import { FavoriteEntityControlsBar } from '../../components/FavoriteEntityControlsBar';
import { selectOptions } from '../../selectors/print/selectOptions';

/* istanbul ignore next */
function mapStateToProps(state: IApplicationState) {
  const printOptions = selectOptions(state);

  return {
    page: state.page,
    favoriteEntities: state.results.favoriteEntities,
    user: state.user,
    total: state.results.total,
    printPhoneNumbers: printOptions.printPhoneNumbers,
  };
}

export const FavoriteEntityControlsBarContainer = connect(mapStateToProps)(FavoriteEntityControlsBar);
